import { PrinterAlertIcon } from './PrinterAlertIcon';

/**
 * author: Austin Andrews
 * id DD64AF52-2610-43D3-A992-9F3FCCB4A576
 * name printer-alert
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/printer-alert.svg
 * tags
 * - Printer 
 * - Home Automation 
 * - Alert / Error 
 */
export const PaperJamIcon = PrinterAlertIcon;
export default PaperJamIcon